// extracted by mini-css-extract-plugin
export default {"box":"viewer-thumb_box__6txYJ","img":"viewer-thumb_img__2Ew97","inner":"viewer-thumb_inner__i1wFg"};